<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										Details Receipt and Payments Reports
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :title="'RECEIPT & PAYMENTS'" :form="form"
										@filterAction="filterAction" :filter="filter"></report-filter>
									<b-button @click="printPDF" class="me-2 btn-sm akkurate-green-btn akkurate-small"
										title="Print"><font-awesome-icon :icon="['fas', 'print']" /></b-button>
									<b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small"
										title="Download"><font-awesome-icon :icon="['fas', 'download']" /></b-button>
								</div>
							</div>
						</div>
						<div class="card-body mx-3 mb-5" ref="pdfContent">
							<div class="row">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution" :current_date="false"
										:title="'NOTE TO RECEIPTS & PAYMENTS'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list_display }}
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-8"></div>
								<div class="col-md-4 text-end">
									<div>
										Terms:
										<span class="fw-bold">{{
											form.terms
										}}</span>
									</div>
									<span class="mt-2">From:
										<strong>{{ form.start_date }}</strong>
										To: <strong>{{ form.end_date }}</strong>
									</span>
								</div>
							</div>
							<div v-if="isBusy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
							<div v-else id="balance-sheet" class="row">
								<div class="col-12 my-2"></div>
								<div class="col-6 col-md-6 px-0 trans_details">
									<b-table-simple responsive outlined bordered>
										<b-thead>
											<b-tr>
												<b-th class="text-center fs-6 akkurate-green"
													colspan="3"><span>RECEIPTS</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<template v-for="(coa_type, headIndex) in coa_types">
												<b-tr>
													<b-td colspan="3" variant="secondary" style="font-weight: bold">
														{{ coa_type.type_name }}
													</b-td>
												</b-tr>

												<template v-for="(coa_head, idx) in coa_type?.coa_heads">
													<b-tr>
														<b-td colspan="3" variant="light" style="font-weight: bold">
															{{ coa_head.display_name }}
														</b-td>
													</b-tr>

													<b-tr v-for="(subhead, subIndex) in (coa_head.subheads || [])"
														class="list-item"
														:key="'cos_subhead_receipt' + subIndex + subhead.code">
														<b-td>
															{{ subhead.display_name || subhead.name }}
															<span v-if="subhead.branch_name"> - ({{ subhead.branch_name
															}})</span>
														</b-td>
														<b-td colspan="2" class="text-end">
															GHS {{
																displayNumber(Number(subhead.receipt_amount).toFixed(2)) }}
														</b-td>
													</b-tr>
													<b-tr variant="success">
														<td class="py-0 px-2 fw-bold">
															TOTAL
														</td>
														<td class="py-0 px-2 fw-bold text-end">
															{{ institution?.currency_code }} {{
																displayNumber(coa_head?.total_receipts) }}
														</td>
													</b-tr>
												</template>
											</template>
										</b-tbody>
										<b-tfoot>
											<b-tr>
												<b-th>Total Receipts</b-th>
												<b-th class="text-end">{{ institution?.currency_code }}
													{{
														displayNumber(
															Number(total_receipts).toFixed(2)
														)
													}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Total Income</b-th>
												<b-th class="text-end">{{ institution?.currency_code }}
													{{
														displayNumber(
															Number(total_incomes).toFixed(2)
														)
													}}</b-th>
											</b-tr>
											<b-tr>
												<b-th colspan="2">Profit/ Loss</b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
								<div class="col-6 col-md-6 px-0 trans_details">
									<b-table-simple responsive outlined bordered>
										<b-thead>
											<b-tr>
												<b-th class="text-center fs-6 akkurate-green"
													colspan="3"><span>PAYMENTS</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<template v-for="(coa_type, headIndex) in coa_types">
												<b-tr>
													<b-td colspan="3" variant="secondary" style="font-weight: bold">
														{{ coa_type.type_name }}
													</b-td>
												</b-tr>

												<template v-for="(coa_head, idx) in coa_type?.coa_heads">
													<b-tr>
														<b-td colspan="3" variant="light" style="font-weight: bold">
															{{ coa_head.display_name }}
														</b-td>
													</b-tr>

													<b-tr v-for="(subhead, subIndex) in (coa_head.subheads || [])"
														class="list-item"
														:key="'cos_subhead_payments' + subIndex + subhead.code">
														<b-td>
															{{ subhead.display_name || subhead.name }}
															<span v-if="subhead.branch_name"> - ({{ subhead.branch_name
															}})</span>
														</b-td>
														<b-td colspan="2" class="text-end">
															GHS {{
																displayNumber(Number(subhead.payment_amount).toFixed(2)) }}
														</b-td>
													</b-tr>
													<b-tr variant="danger">
														<td class="py-0 px-2 fw-bold">
															TOTAL
														</td>
														<td class="py-0 px-2 fw-bold text-end">
															{{ institution?.currency_code }} {{
																displayNumber(coa_head?.total_payments) }}
														</td>
													</b-tr>
												</template>
											</template>
										</b-tbody>
										<b-tfoot>
											<b-tr>
												<b-th>Total Payments</b-th>
												<b-th class="text-end">{{ institution?.currency_code }}
													{{
														displayNumber(
															Number(total_payments).toFixed(2)
														)
													}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Total Expenses</b-th>
												<b-th class="text-end">{{ institution?.currency_code }}
													{{
														displayNumber(
															Number(total_expenses).toFixed(2)
														)
													}}</b-th>
											</b-tr>
											<b-tr>
												<b-th colspan="2" class="text-end">{{
													displayNumber(
														Number(difference).toFixed(2)
													)
												}}</b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "../form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			form: {
				start_date: this.getBeginningOfYear(),
				end_date: new Date().toISOString().substr(0, 10),
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "Periodic",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status:[],
			},
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				terms: true,
				coa: false,
				voucher_status: false,
				start_date: true,
				end_date: true,
				loan_status:false,
			},
			search: "Search",
			isBusy: false,
			isSearching: false,
			selected_num: "10",
			numbers_options: [10, 50, 100, 500],
			isLoadingInstitution: false,
			institution: "",
			start_date: "",
			end_date: "",
			// New data structure from the system endpoint
			total_receipts: 0,
			total_payments: 0,
			net_cash_flow: 0,
			// branch_list: [],
			perPage: 20,
			currentPage: 1,
			items: [],
			coa_types: [],  // add this if missing
		};
	},
	computed: {
		rows() {
			return this.items.length;
		},
		branch_list_display() {
			const selected = this.form.branches || [];
			const all = this.form.branch_options || [];

			if (selected.length > 0) {
				return selected.map(b => b.name).join(", ");
			}
			if (all.length > 0) {
				return all.map(b => b?.name).join(", ");
			}
			return "";
		},
	},

	created() {
		this.getInstitution();
		this.getBalanceSheets();
		this.getProductDropdown();
	},
	methods: {
		async getBalanceSheets() {
			this.items = [];
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			await ApiService.post(
				"/reports/financials/receipts-payments/default",
				{
					start_date: this.form.start_date,
					end_date: this.form.end_date,
					terms: this.form.terms,
					branches: this.form.branches.map(index => index?.id ?? []),
				}
			)
				.then((response) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					var res = response.data;
					// console.log(res);

					// Set the new data structure
					this.coa_types = res.grouped_coa || [];
					// console.log(res.grouped_coa );
					this.total_receipts = res.total_receipts || 0;
					this.total_payments = res.total_payments || 0;
					this.net_cash_flow = res.net_cash_flow || 0;

					this.total_incomes = res.grant_monthly_total_incomes || 0;
					this.total_expenses = res.grant_monthly_total_expenses || 0;

					this.difference = this.total_incomes - this.total_expenses || 0
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					console.log(error);
				});
		},

		async getProductDropdown() {
			this.isBusy = true;
			this.search = "Processing...";
			await ApiService.query("/reports/controls/products/dropdown")
				.then((response) => {
					this.isBusy = false;
					this.search = "Search";
					this.form.branch_options = response.data.branches;
					this.form.product_options = response.data.products;
					this.form.coa_options = response.data.coa_subheads;
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
				});
		},

		downloadPDF() {
			const content = this.$refs.pdfContent;
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2],
				filename: "detailed_receipt_payment_statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },
				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},

		filterAction() {
			this.getBalanceSheets();
		},

		printPDF() {
			const content = this.$refs.pdfContent;
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2],
				filename: "detailed_receipt_payment_statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },
				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					var pdfUrl = URL.createObjectURL(pdfBlob);
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx";
			const imageUrl = "/default_logo.png";

			const institutionName = this.institution.name || '';
			const institutionMotto = this.institution.motto || '';
			const institutionAddress = this.institution.address || '';
			const institutionPhone = this.institution.telephone || '';
			const institutionEmail = this.institution.email || '';
			const date = "FROM: " + this.form.start_date + " TO: " + this.form.end_date;
			const terms = "TERMS: " + this.form.terms;

			try {
				const response = await fetch(fileUrl);
				if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
				const arrayBuffer = await response.arrayBuffer();

				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);
				const ws = wb.getWorksheet(1);

				// Add image if available
				try {
					const imageResponse = await fetch(imageUrl);
					if (imageResponse.ok) {
						const imageBuffer = await imageResponse.arrayBuffer();
						const imageId = wb.addImage({ buffer: imageBuffer, extension: "png" });
						ws.addImage(imageId, { tl: { col: 0, row: 0 }, ext: { width: 300, height: 200 } });
					}
				} catch (imageError) {
					console.warn("Could not load image:", imageError);
				}

				// Institution details
				const startRow = 1;
				ws.getCell(`L${startRow}`).value = institutionName;
				ws.getCell(`L${startRow}`).font = { bold: true, size: 14 };
				ws.getCell(`L${startRow + 1}`).value = institutionAddress;
				ws.getCell(`L${startRow + 1}`).font = { size: 12 };
				ws.getCell(`L${startRow + 2}`).value = institutionMotto;
				ws.getCell(`L${startRow + 2}`).font = { size: 12 };
				ws.getCell(`L${startRow + 3}`).value = institutionPhone;
				ws.getCell(`L${startRow + 3}`).font = { size: 12 };
				ws.getCell(`L${startRow + 4}`).value = institutionEmail;
				ws.getCell(`L${startRow + 4}`).font = { size: 12 };
				ws.getCell(`L${startRow + 6}`).value = date;
				ws.getCell(`L${startRow + 6}`).font = { size: 12 };
				ws.getCell(`L${startRow + 7}`).value = terms;
				ws.getCell(`L${startRow + 7}`).font = { size: 12 };
				ws.getCell(`L${startRow + 8}`).value = "Branch(es): " + this.branch_list;
				ws.getCell(`L${startRow + 8}`).font = { size: 12 };
				ws.getColumn("L").width = 50;

				// Headers for Receipts and Payments
				const headerRowNum = 13;
				const headerRow = ws.getRow(headerRowNum);
				headerRow.font = { bold: true };
				ws.mergeCells(headerRowNum, 1, headerRowNum, 2);
				ws.mergeCells(headerRowNum, 3, headerRowNum, 4);
				ws.getCell(headerRowNum, 1).value = "Receipts";
				ws.getCell(headerRowNum, 1).alignment = { horizontal: "center" };
				ws.getCell(headerRowNum, 3).value = "Payments";
				ws.getCell(headerRowNum, 3).alignment = { horizontal: "center" };
				headerRow.commit();

				let currentRowNum = headerRowNum + 1;

				// Loop through coa_types (each coa_type)
				for (const coaType of this.coa_types) {
					// COA Type row for Receipts and Payments
					const typeRow = ws.getRow(currentRowNum);
					typeRow.getCell(1).value = coaType.type_name || '';
					typeRow.getCell(1).font = { bold: true };
					typeRow.getCell(3).value = coaType.type_name || '';
					typeRow.getCell(3).font = { bold: true };
					typeRow.commit();
					currentRowNum++;

					// Loop through coa_heads inside this coa_type
					for (const coaHead of coaType.coa_heads) {
						// COA Head row
						const headRow = ws.getRow(currentRowNum);
						headRow.getCell(1).value = coaHead.display_name || '';
						headRow.getCell(1).font = { italic: true, bold: true };
						headRow.getCell(3).value = coaHead.display_name || '';
						headRow.getCell(3).font = { italic: true, bold: true };
						headRow.commit();
						currentRowNum++;

						// Loop through subheads inside this coa_head
						for (const subhead of coaHead.subheads || []) {
							const subRow = ws.getRow(currentRowNum);
							// Receipt side
							subRow.getCell(1).value = subhead.display_name || subhead.name || '';
							subRow.getCell(2).value = Number(subhead.receipt_amount || 0).toFixed(2);
							// Payment side
							subRow.getCell(3).value = subhead.display_name || subhead.name || '';
							subRow.getCell(4).value = Number(subhead.payment_amount || 0).toFixed(2);
							subRow.commit();
							currentRowNum++;
						}
					}

					// Subtotal row for this coa_type
					const subtotalRow = ws.getRow(currentRowNum);
					subtotalRow.getCell(1).value = "TOTAL";
					subtotalRow.getCell(1).font = { bold: true };
					subtotalRow.getCell(2).value = Number(coaType.total_receipts || 0).toFixed(2);
					subtotalRow.getCell(2).font = { bold: true };
					subtotalRow.getCell(3).value = "TOTAL";
					subtotalRow.getCell(3).font = { bold: true };
					subtotalRow.getCell(4).value = Number(coaType.total_payments || 0).toFixed(2);
					subtotalRow.getCell(4).font = { bold: true };
					subtotalRow.commit();
					currentRowNum++;
				}

				// Grand totals row
				const grandTotalRow = ws.getRow(currentRowNum);
				grandTotalRow.getCell(1).value = "Total Receipts";
				grandTotalRow.getCell(1).font = { bold: true };
				grandTotalRow.getCell(2).value = Number(this.total_receipts || 0).toFixed(2);
				grandTotalRow.getCell(2).font = { bold: true };
				grandTotalRow.getCell(3).value = "Total Payments";
				grandTotalRow.getCell(3).font = { bold: true };
				grandTotalRow.getCell(4).value = Number(this.total_payments || 0).toFixed(2);
				grandTotalRow.getCell(4).font = { bold: true };
				grandTotalRow.commit();
				currentRowNum++;

				// Add Income row
				const incomeRow = ws.getRow(currentRowNum);
				incomeRow.getCell(1).value = "Total Income";
				incomeRow.getCell(1).font = { bold: true };
				incomeRow.getCell(2).value = Number(this.total_incomes || 0).toFixed(2);
				incomeRow.getCell(2).font = { bold: true };
				incomeRow.commit();
				currentRowNum++;

				// Add Expenses row
				const expensesRow = ws.getRow(currentRowNum);
				expensesRow.getCell(1).value = "Total Expenses";
				expensesRow.getCell(1).font = { bold: true };
				expensesRow.getCell(2).value = Number(this.total_expenses || 0).toFixed(2);
				expensesRow.getCell(2).font = { bold: true };
				expensesRow.commit();
				currentRowNum++;

				// Add Difference row
				const differenceRow = ws.getRow(currentRowNum);
				differenceRow.getCell(1).value = "Profit/ Loss";
				differenceRow.getCell(1).font = { bold: true };
				differenceRow.getCell(2).value = Number(this.difference || 0).toFixed(2);
				differenceRow.getCell(2).font = { bold: true };
				differenceRow.commit();
				currentRowNum++;

				// Set column widths (optional, you can adjust if needed)
				ws.getColumn(1).width = 30; // Description
				ws.getColumn(2).width = 15; // Amount
				ws.getColumn(3).width = 30; // Payment description (if needed)
				ws.getColumn(4).width = 15; // Payment amount (if needed)

				const now = new Date();

				const pad = (num) => num.toString().padStart(2, '0');

				// Generate and download Excel file
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = `Note_to_Receipt_and_Payment_${this.form.start_date}_to_${this.form.end_date}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(link.href);

			} catch (err) {
				console.error("Error generating Excel file:", err);
				this.$bvToast.toast('Failed to generate Excel file. Please try again.', {
					title: 'Export Error',
					variant: 'danger',
					solid: true
				});
			}
		},
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},

		displayNumber(value) {
			// Add your number formatting logic here
			return parseFloat(value).toLocaleString('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		},

		getBeginningOfYear() {
			const now = new Date();
			return new Date(now.getFullYear(), 0, 1).toISOString().substr(0, 10);
		},
	},
};
</script>